import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page38',
  templateUrl: './page38.component.html',
  styleUrls: ['./page38.component.css']
})
export class Page38Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
